// extracted by mini-css-extract-plugin
export default {"wrap":"Residential_wrap__LoXUL","content":"Residential_content__uInEN","subtitle":"Residential_subtitle__6sPg2","image":"Residential_image__CovCN"};